import fakeStore from "../assets/projects/fakestore.webp";
import cocktails from "../assets/projects/cocktails.webp";
import countries from "../assets/projects/countries.webp";
import hangman from "../assets/projects/hangman.webp";
import spaceTourism from "../assets/projects/space-tourismwebp.webp";
import sunnySide from "../assets/projects/sunny-side.webp";
import tictactoe from "../assets/projects/tictactoe.webp";

const PROJECTS_DATA = [
  {
    id: 1,
    title: "Lotus Store - E-Commerce Web App",
    technologies:
      "React(hooks, styled-components)/react-router-dom, Firebase/Firestore(firebase auth,firestore database)",
    description:
      "It's a Web App where a user can create an account, modify profile data, add/remove items to cart, check cart items, proceed to checkout. Throught the project i've learn how to use firebase database, how to use hooks, how react router dom works.",
    img: fakeStore,
    position: "left",
    live: "https://fake-store-app-9a2fd.web.app/",
    repo: "https://github.com/cataraul/ecomm",
  },
  {
    id: 2,
    title: "Cocktails Web App",
    technologies: "React(styled-components, framer-motion)",
    description:
      "Web app that displays all the drinks from an API, lets user search for them and check their recipes. Making this project made me learn more about react and libraries, about styling and ux in general.",
    img: cocktails,
    position: "right",
    live: "https://cataraul.github.io/cocktails/",
    repo: "https://github.com/cataraul/cocktails",
  },
  {
    id: 3,
    title: "SunnySide",
    technologies: "HTML, CSS, SCSS, JAVASCRIPT",
    description:
      "Front-End Mentor Challenge made to use and learn Scss, to practice layouts and responsive design. ",
    img: sunnySide,
    position: "left",
    live: "https://cataraul.github.io/sunny-side-frontendmentor-challenge/",
    repo: "https://github.com/cataraul/sunny-side-frontendmentor-challenge",
  },
  {
    id: 4,
    title: "Around The World!",
    technologies: "React ,  react-routet-dom",
    description:
      "Web app that displays all the countries in the world from an API. All the countries data was fetch from an API and by building this project i got to learn more about how to consume APIs, how to display the data. I've also added a theme changer, that keeps the state in the localStorage.",
    img: countries,
    position: "right",
    live: "https://cataraul.github.io/countries/",
    repo: "https://github.com/cataraul/countries",
  },
  {
    id: 5,
    title: "Space tourism",
    technologies: "React(styled-components, framer-motion)/react-router-dom",
    description:
      "Web app that is a part of a Front-End Mentor Challenge, where i got the design and had to implement it. Learned how to use react-router-dom and got a change to add some animations using framer-motion aswell as practicing my responsive design skills.",
    img: spaceTourism,
    position: "left",
    live: "https://cataraul.github.io/space-tourism/",
    repo: "https://github.com/cataraul/space-tourism",
  },
  {
    id: 6,
    title: "Hangman",
    technologies: "HTML, CSS , JAVASCRIPT",
    description:
      "Simple Hangman game, made to learn more about Javascript in general.",
    img: hangman,
    position: "right",
    live: "https://cataraul.github.io/hangman/",
    repo: "https://github.com/cataraul/hangman",
  },
  {
    id: 7,
    title: "TicTacToc",
    technologies: "HTML, CSS, JAVASCRIPT",
    description: "TicTacToe game",
    img: tictactoe,
    position: "left",
    live: "https://cataraul.github.io/TicTacToe/",
    repo: "https://github.com/cataraul/TicTacToe",
  },
];

export default PROJECTS_DATA;
